module.exports = __webpack_public_path__ + "media/images/illustrations/your-one-stop-partner-21cfba6c3f0c7410cd8f3e1ce31f4abb.svg";